import Vue from 'vue'
import {get,post} from '@/util/http';
import api from '@/util/api'


// 结果输出
const end = (res,data,methods=()=>{},title = '提示') =>{
    // 1.处理失败结果
    if(res.code != 1){
        // alert(title)
        return false
    }
    // 2.成功结果的方法（从外面引入）
    methods()
    // 3.返回结果
    return data
}


const menu = {
    state:{
        currentPage: 0,
    },
    mutations:{
        McurrentPage(state, cur){
            state.currentPage = cur;
        }
    },
    actions:{
        async queryApply({},form){
            const res = await post('/queryApply',form)
            return end(res,true,()=>{
                // 如果成功要commit或其他处理写在这里
            })
        },
    }
}

export default menu


// WEBPACK FOOTER //
// ./src/store/modules/menu.js